import styled from 'styled-components';
import { AvInput } from 'availity-reactstrap-validation';

export default styled(AvInput)`
  text-align: right;
`;
